import { render, staticRenderFns } from "./StampProcedure.vue?vue&type=template&id=3590c1d5&"
import script from "./StampProcedure.vue?vue&type=script&lang=js&"
export * from "./StampProcedure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports